(function () {
    'use strict';

    angular.module('finansApp.employeeService', []).factory('employeeService', employeeService);
    

    function State() {
        this.employees = [];
        this.filteredEmployees = [];
        this.searchQuery = "";
        this.selectedDepartments = {};
        this.selectedSubjects = {};
        this.associates = {};
        this.associates.list = [];
        this.associates.headline = "";
        this.associates.splitList = false;
    }

    employeeService.$inject = ['$resource', '$q', 'apiUrl', '$location'];

    function employeeService($resource, $q, apiUrl, $location) {
        var state = new State();

        var resource = $resource(apiUrl + "EmployeeApi/:methodName/", {}, {
            getEmployees: { method: 'GET', params: { methodName: 'GetEmployees'}, isArray: false }
        });

        // Public
        var service = {
            state: state,
            getEmployees: getEmployees,
            filterEmployees: filterEmployees
        };

        function init() {
        }

        init();

        function getEmployees() {

            var deferred = $q.defer(); 

            // Get from API
            resource.getEmployees().$promise.then(function(response) {

                if(response.Employees) {
                    state.employees = response.Employees;
                    state.filteredEmployees = response.Employees;
                }

                if(response.DisplayAssociatesSeparately.length) {
                    state.associates.list = response.DisplayAssociatesSeparately;
                    state.associates.headline = response.AssociatesHeadline;
                }

                deferred.resolve();

            }, function() {
                deferred.reject();
            });


            return deferred.promise;
        }

        function filterEmployees() {
            var temp1 = [];
            var temp2 = [];

            if(Object.keys(state.selectedSubjects).length) {

                // Loop over the keys
                for (var key in state.selectedSubjects){
                    var key = key * 1

                    for (var i = state.employees.length - 1; i >= 0; i--) {
                        if(contains.call(state.employees[i].SubjectAreasArr, key)) {
                            temp1.push(state.employees[i])
                        }
                    }
                }

            } else {
                temp1 = state.employees;
            }

            if(Object.keys(state.selectedDepartments).length) {

                // Loop over the keys
                for (var key in state.selectedDepartments){
                    var key = key * 1

                    for (var i = temp1.length - 1; i >= 0; i--) {
                        if(contains.call(temp1[i].DepartmentArr, key)) {
                            temp2.push(temp1[i])
                        }
                    }
                }
            } else {
                temp2 = temp1;
            }

            state.filteredEmployees = temp2;

            splitAssociates();

        }

        function splitAssociates() {
            var selectedDepartmentsArr = Object.keys(state.selectedDepartments);
            var selectedDepartmentsId = selectedDepartmentsArr.length == 1 ? selectedDepartmentsArr[0] * 1 : null;
            
            if(state.associates.list.length && selectedDepartmentsId && contains.call(state.associates.list, selectedDepartmentsId)) {
                state.associates.splitList = true;
            } else {
                state.associates.splitList = false;
            }
        }


        var contains = function(needle) {
            // Per spec, the way to identify NaN is that it is not equal to itself
            var findNaN = needle !== needle;
            var indexOf;

            if(!findNaN && typeof Array.prototype.indexOf === 'function') {
                indexOf = Array.prototype.indexOf;
            } else {
                indexOf = function(needle) {
                    var i = -1, index = -1;

                    for(i = 0; i < this.length; i++) {
                        var item = this[i];

                        if((findNaN && item !== item) || item === needle) {
                            index = i;
                            break;
                        }
                    }

                    return index;
                };
            }

            return indexOf.call(this, needle) > -1;
        };


        
        return service;



    }

})();

